module.exports = __webpack_public_path__ + "img/shortAnswer.b0d06677.svg";